<template>
  <h1>NotFound</h1>
</template>

<script>
export default {
  name: "not-found"
};
</script>

<style scoped></style>
